// extracted by mini-css-extract-plugin
export default {"diff":"Diff-module__diff--GKRfQ","diffTargetable":"Diff-module__diffTargetable--hLfiB","diffHeaderWrapper":"Diff-module__diffHeaderWrapper--J03RC"};